module.exports = __webpack_public_path__ + "static/img/termsofuse.4bcb5f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FFP/images/termsofuse.png
// module id = w81n
// module chunks = 0